import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('BaseEntity')
export class BaseEntity {
  @JsonProperty('createdAt', String, true) createdAt: string = undefined;
  @JsonProperty('updatedAt', String, true) updatedAt: string = undefined;
}
